import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
interface InfoTooltipProps {
  title: string;
}

export const InfoTooltip = ({ title }: InfoTooltipProps) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={title}
      placement="top"
      arrow
      data-testid="info-tooltip"
      style={{ marginLeft: '4px' }}
    >
      <FontAwesomeIcon
        icon={faCircleInfo}
        size="lg"
        color={theme.palette.common.azureBlue}
      />
    </Tooltip>
  );
};
